import { Box, CircularProgress, css } from '@mui/material';
import { useEffect } from 'react';
import alertify from 'alertifyjs';

import { LayerDashboardTab } from './LayerDashboardTab';
import { LayerDashboardTabProvider } from '../../features/layer-dashboard/context/LayerDashboardContext';
import { useGetLayerDashboardInfo } from 'features/layer-dashboard/api/layerDashboardApi';
import { getLayerDashboardUrlParams } from 'features/layer-dashboard/utils/layoutDashboardUrlUtils';

const urlParams = getLayerDashboardUrlParams();

const loading = css({
    background: '#c8c8c8',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export const LayerDashboard = () => {
    const { data, isLoading, isError } = useGetLayerDashboardInfo(urlParams.layerToken);

    useEffect(() => {
        if (isError) {
            alertify.alert('Um erro ocorreu');
        }
    }, [isError]);

    return (
        <Box sx={{ width: '100%' }}>
            {isLoading &&
                <Box css={loading}>
                    <CircularProgress></CircularProgress>
                </Box>
            }

            <LayerDashboardTabProvider tabsAlreadyRendered={[0]} display={true} index={0}>
                <LayerDashboardTab data={data} />
            </LayerDashboardTabProvider>
        </Box>
    );
};